import Breadcrumbs from '@v2/shared/components/Breadcrumbs';
import ContentCard from '@v2/shared/components/ContentCard';
import PageHeading from '@v2/shared/components/PageHeading';

/**
 * /accessibility.
 *
 * The legacy page's four sections were already `<h2>`s under the H1, so unlike TopMags'
 * there is no heading level to fix; they are the cards' headings here. The words are
 * unchanged.
 */
export default function Accessibility() {
  return (
    <>
      {/* "Accessibility Policy", as the legacy trail said, not the rail's shorter label. */}
      <Breadcrumbs items={[{ label: 'Home', href: '/' }, { label: 'Accessibility Policy' }]} />

      <PageHeading eyebrow="Customer Information">MagSpot.com Accessibility Policy</PageHeading>

      <div className="prose mt-6 flex flex-col gap-6">
        <ContentCard>
          <h2>Our Commitment to Inclusion</h2>
          <p>
            At MagSpot.com, we believe that information and entertainment should be accessible to
            everyone. We are dedicated to ensuring our website is user-friendly and navigable for
            all visitors, including those with visual, hearing, cognitive, or motor impairments.
          </p>
        </ContentCard>

        <ContentCard>
          <h2>Standards &amp; Guidelines</h2>
          <p>
            To achieve this, MagSpot is actively working to align its digital experience with the
            Web Content Accessibility Guidelines (WCAG) 2.1 at Level AA standards. We regularly
            review our site to identify and fix usability issues, ensuring a seamless shopping
            experience for our entire community.
          </p>
        </ContentCard>

        <ContentCard>
          <h2>Ongoing Improvements</h2>
          <p>
            Please be aware that our efforts are ongoing. While we strive for comprehensive
            accessibility, you may encounter some pages or features that are still being updated or
            for which the optimal technological solution is currently being implemented. We
            appreciate your patience as we continue these enhancements.
          </p>
        </ContentCard>

        <ContentCard>
          <h2>Need Assistance?</h2>
          {/*
           * No bottom margin: this paragraph runs straight into the list it introduces,
           * which is what the legacy page's inline `margin-bottom: 0` did. `mb-0` rather
           * than `m-0` — inside prose only the longhands are raised to !important, so the
           * shorthand loses to the top margin. See PR #1816.
           */}
          <p className="mb-0">
            If you have trouble viewing or navigating the content on this website, or notice any
            content, feature, or functionality that you believe is not fully accessible to people
            with disabilities, please contact our team immediately.
          </p>
          <ul>
            <li>
              <strong>Email:</strong> <a href="mailto:hello@magspot.com">hello@magspot.com</a>
            </li>
            <li>
              <strong>Phone:</strong> 1-800-616-3800
            </li>
            <li>
              <strong>Hours:</strong> Monday - Friday: 9:00 a.m. to 5:00 p.m (PST Time Zone)
              Saturday - Sunday: Closed
            </li>
          </ul>
          <p>
            We take your feedback seriously and will consider it as we evaluate ways to accommodate
            all of our customers and our overall accessibility policies.
          </p>
        </ContentCard>
      </div>
    </>
  );
}

Accessibility.layoutName = 'Layouts.Institutional';
